import { FC } from 'react'

import { PrimaryDottedButton } from '../Buttons/PrimaryDottedButton'

interface ShowAllPlaylistsButtonProps {
  onClick?: () => void
  showAll: boolean
}

export const ShowAllPlaylistsButton: FC<ShowAllPlaylistsButtonProps> = ({
  onClick,
  showAll,
}) => (
  <PrimaryDottedButton onClick={onClick}>
    {showAll ? 'Hide all playlists.' : 'Show all playlists'}
  </PrimaryDottedButton>
)
